import React from "react";

import { RadioButtonGroupItem } from "./radio-button-group-item";
import type { RadioButtonGroupRootProps } from "./radio-button-group-root";
import { RadioButtonGroupRoot } from "./radio-button-group-root";

export {
  RADIO_BUTTON_GROUP_DIRECTION,
  RADIO_BUTTON_GROUP_ORIENTATION,
} from "./radio-button-group-item";

type RadioButtonGroupCmp<P> = React.FunctionComponent<P> & {
  Item: typeof RadioButtonGroupItem;
};

export type RadioButtonGroupProps = RadioButtonGroupRootProps;

export const RadioButtonGroup: RadioButtonGroupCmp<RadioButtonGroupProps> = ({
  children,
  ...props
}: RadioButtonGroupProps) => {
  return <RadioButtonGroupRoot {...props}>{children}</RadioButtonGroupRoot>;
};

RadioButtonGroup.Item = RadioButtonGroupItem;

RadioButtonGroup.displayName = "RadioButtonGroup";
